/**
 * The claim types a Tech Enablement Fee can apply to.
 */
export enum TechEnablementFeeClaimTypeModel {
	/**
	 * The fee applies to all claims.
	 */
	AllClaims = 1
}
